/**
 * Billing API client
 */

import { fetchApi } from './fetch';

export interface BillingStatus {
  subscriptionTier: string;
  trialEndsAt: string | null;
  trialDaysLeft: number | null;
  trialActive: boolean | null;
  cancelAt: string | null;
  monthlyUsage: {
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
    opCount: number;
  };
  stripeConfigured: boolean;
}

export interface BillingInvoice {
  id: string;
  date: string | null;
  amount: number; // USD dollars (not cents)
  status: string | null;
  pdfUrl: string | null;
}

export async function getBillingStatus(): Promise<BillingStatus> {
  return fetchApi<BillingStatus>('/billing/status');
}

export async function createCheckoutSession(): Promise<{ url: string }> {
  return fetchApi<{ url: string }>('/billing/checkout', { method: 'POST' });
}

export async function getBillingPortalUrl(): Promise<{ url: string }> {
  return fetchApi<{ url: string }>('/billing/portal', { method: 'POST' });
}

export async function getBillingInvoices(): Promise<{ invoices: BillingInvoice[] }> {
  return fetchApi<{ invoices: BillingInvoice[] }>('/billing/invoices');
}

export async function cancelSubscription(): Promise<{ cancelAt: string | null }> {
  return fetchApi<{ cancelAt: string | null }>('/billing/cancel', { method: 'POST' });
}

export async function reactivateSubscription(): Promise<{ cancelAt: null }> {
  return fetchApi<{ cancelAt: null }>('/billing/reactivate', { method: 'POST' });
}
